(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('editNote', {
            bindings: {
                editObservation: '<',
                cancel: '&',
                update: '&',
                delete: '&'
            },
            templateUrl: 'app/entities/observation/edit-observation-component.html',
            controller: ['$timeout',
                function($timeout) {
                    var $ctrl = this;

                    $ctrl.onCancel = onCancel;
                    $ctrl.onUpdate = onUpdate;
                    $ctrl.onDelete = onDelete;

                    $timeout(function() {
                        angular.element('#description').focus();
                    });

                    function onUpdate() {
                        $ctrl.update();
                    }

                    function onCancel() {
                        $ctrl.cancel();
                    }

                    function onDelete() {
                        $ctrl.delete();
                    }
                }
            ]
        });
})();
